import type { Namespace, NamespaceMap } from '../../../types.js';

export const sharedNamespace: Namespace = {
  'common.actions.save': 'Save',
  'common.actions.cancel': 'Cancel',
  'common.actions.create': 'Create',
  'common.actions.delete': 'Delete',
  'common.actions.confirm': 'Confirm',
  'common.labels.loading': 'Loading…',
  'common.labels.empty': 'Nothing found',
  'common.labels.search': 'Search',
  'common.greeting': 'Hello, {name}!',
  'auth.login.title': 'Sign in',
  'auth.login.submit': 'Sign in',
  'auth.login.email': 'Email',
  'auth.login.password': 'Password',
  'auth.logout.label': 'Sign out',
  'errors.network': 'Network error. Please try again.',
  'errors.forbidden': 'Access denied.',
  'errors.not_found': 'Not found.',
  'errors.unauthorized': 'Sign-in required.',
  'errors.internal': 'Internal error. We are already looking into it.',
  'validation.required': 'This field is required',
  'validation.email': 'Enter a valid email',
  'validation.min_length': 'At least {count} characters',
  'validation.max_length': 'At most {count} characters',
  'validation.number': 'Enter a number',
  'roles.owner': 'Owner',
  'roles.admin': 'Administrator',
  'roles.member': 'Member',
  'roles.viewer': 'Viewer',
  'roles.guest': 'Guest',
  'dates.today': 'Today',
  'dates.yesterday': 'Yesterday',
  'dates.tomorrow': 'Tomorrow',
  'dates.month.january': 'January',
  'dates.month.february': 'February',
  'dates.days_ago': {
    one: '{count} day ago',
    other: '{count} days ago',
    zero: 'just now',
  },
};

export const enShared: NamespaceMap = {
  shared: sharedNamespace,
};
